<mat-divider></mat-divider>
<footer>Copyright &copy; 2021 &mdash; <a target="_blank" href="https://www.primeinfor.com.br/">Prime
    Automação</a></footer>